import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefineTemplate } from './common/components/option-component/optionFascicolo/templateComponent/define-template';
import {
  AdempimentiInevasiViewComponent
} from './core/components/adempimenti-inevasi/adempimenti-inevasi-view.component';
import {
  AttivitaCompletareViewComponent
} from './core/components/attivita-completare/attivita-completare-view.component';
import { WelcomeBoardComponent } from './core/components/body/welcome-board.component';
import { ProfiloUtenteComponent } from './core/components/profilo-utente/profilo-utente.component';
import { ErrorPageComponent } from './core/components/error-page/error-page.component';
import { LoginComponent } from './core/components/login/login.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { NotificationsViewComponent } from './core/components/notifications/notifications-view.component';
import {
  ProssimiAdempimentiViewComponent
} from './core/components/prossimi-adempimenti/prossimi-adempimenti-view.component';
import { UrlSettingsCore } from './core/configuration/url-settings-core';
import { AuthGuardAmministrazioneService } from './guards/auth.guard-amministrazione';
import { authGuardVisibilityFN } from './guards/auth.guard-visibility';
import { NomiDescrittoriSezione } from './common/configuration/nomi-descrittori-sezione';
import { authGuardGenDoc } from './guards/auth.guard-generazione-doc';
import { CancelleriaTelematicaGuard } from './pda/guards/cancelleria-telematica.guard';
import { OutlookAuthLpComponent } from './core/components/login/outlook-auth-lp/outlook-auth-lp.component';
import { RefreshTokenLpComponent } from './core/components/login/outlook-auth-lp/refresh-token-lp/refresh-token-lp.component';
import { ProfileGuard } from './utility/guards/profile/profile.guard';
import { EmlPreviewComponent } from './common/components/file-preview/eml/eml-preview.component';
import { EmlPreviewResolver } from './common/components/file-preview/resolvers/eml-preview.resolver';
import { ZipPreviewComponent } from './common/components/file-preview/zip/zip-preview.component';
import { ZipPreviewResolver } from './common/components/file-preview/resolvers/zip-preview.resolver';
import { PdfPreviewResolver } from './common/components/file-preview/resolvers/pdf-preview.resolver';
import { PdfReaderComponent } from './common/components/file-preview/pdf-reader/pdf-reader.component';
import { ForbiddenComponent } from './core/components/forbidden/forbidden.component';
import { LoginGuard } from './core/components/login/login.guard';

const routes: Routes = [
  { path: '', redirectTo: UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD, pathMatch: 'full',data:{ title: "Agenda Legale" } },
  { path: UrlSettingsCore.URL_LOGIN, component: LoginComponent, canActivate: [LoginGuard], data: {title: 'Login'} },
  // { path: UrlSettingsCore.URL_AUTH_OUTLOOK, component: OutlookAuthLpComponent },
  { path: UrlSettingsCore.URL_PROFILO_UTENTE,component: ProfiloUtenteComponent , canMatch:[ProfileGuard], data: {title: 'Profilo utente'}},
  { path: UrlSettingsCore.URL_ERROR_PAGE, component: ErrorPageComponent, data: {title: 'Pagina di errore'}},
  { path: UrlSettingsCore.URL_FORBIDDEN, component: ForbiddenComponent, data: {title: 'Accesso negato'} },
  { 
    path: UrlSettingsCore.URL_EML_FILE_PREVIEW_REF + '/:refDocumentale', 
    component: EmlPreviewComponent,
    data: {title: 'Anteprima file email'},
    resolve: {
      documento: EmlPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_ZIP_FILE_PREVIEW_REF + '/:refDocumentale',
    component: ZipPreviewComponent,
    data: {title: 'Anteprima file zip'},
    resolve: {
      documento: ZipPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_PDF_FILE_PREVIEW_REF + '/:refDocumentale',
    component: PdfReaderComponent,
    data: {title: 'Anteprima file pdf'},
    resolve: {
      documento: PdfPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_PDF_FILE_PREVIEW_REF + '/:idDocumento' + '/:type' + '/:versione',
    component: PdfReaderComponent,
    data: {title: 'Anteprima file p7m'},
    resolve: {
      documento: PdfPreviewResolver
    }
  },
  { 
    path: UrlSettingsCore.URL_EML_FILE_PREVIEW + '/:idDocumento', 
    component: EmlPreviewComponent,
    data: {title: 'Anteprima file email'},
    resolve: {
      documento: EmlPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_ZIP_FILE_PREVIEW + '/:idDocumento',
    component: ZipPreviewComponent,
    data: {title: 'Anteprima file zip'},
    resolve: {
      documento: ZipPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_PDF_FILE_PREVIEW + '/:idDocumento',
    component: PdfReaderComponent,
    data: {title: 'Anteprima file pdf'},
    resolve: {
      documento: PdfPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_PDF_FILE_PREVIEW + '/:idDocumento' + '/:type',
    component: PdfReaderComponent,
    data: {title: 'Anteprima file p7m'},
    resolve: {
      documento: PdfPreviewResolver
    }
  },
  {
    path: UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD,
    component: WelcomeBoardComponent,
    data:{ title: "Agenda Legale" }
  },
  {
    path: UrlSettingsCore.URL_VISUALIZZA_DASHBOARD,
    data:{ title: "Dashboard" },
    // component: DashboardComponent,
    loadChildren: () =>
      import(
        "./dashboard/dashboard.module"
      ).then((m) => m.DashboardModule),
  },
  {
    path: UrlSettingsCore.URL_PROSSIMI_ADEMPIMENTI,
    component: ProssimiAdempimentiViewComponent,
    data: {title: 'Prossimi adempimenti'}
  },
  {
    path: UrlSettingsCore.URL_ADEMPIMENTI_INEVASI,
    component: AdempimentiInevasiViewComponent,
    data: {title: 'Adempimenti inevasi'}
  },
  {
    path: UrlSettingsCore.URL_NOTIFICHE_UTENTE,
    component: NotificationsViewComponent,
    data: {title: 'Notifiche'}
  },
  {
    path: UrlSettingsCore.URL_ATTIVITA_COMPLETARE,
    component: AttivitaCompletareViewComponent,
    data: {title: 'Attività da completare'}
  },
  {
    canActivate: [authGuardGenDoc],
    data: { descrittore: NomiDescrittoriSezione.DESCRITTORE_GENERAZIONE_DOCUMENTO },
    path:
      'defineTemplate/:tipoPratica/:tipoFascicolo/:idFascicolo/:idSezione/:idTipoFascicolo',
    component: DefineTemplate,
  },
  {
    path: UrlSettingsCore.URL_RICERCA,
    data: {title: 'Ricerca'},
    // loadChildren: './search/ricerca.module#RicercaModule'
    loadChildren: () =>
      import('./search/ricerca.module').then((m) => m.RicercaModule),
  },
  {
    path: UrlSettingsCore.URL_AMMINISTRAZIONE, data: {descrittore: ['GestioneTipologiche', 'GestioneUtenti', 'GestioneProfili', 'GestioneTabelle', 'GestioneAnagrafiche', 'GestioneFormulario', 'GestioneMetadati','CruscottoNotifiche', 'CruscottoConservazione'], title: "Amministrazione"},
    // loadChildren: './amministrazione/amministrazione.module#AmministrazioneModule'
    canActivate: [AuthGuardAmministrazioneService],
    loadChildren: () =>
      import('./amministrazione/amministrazione.module').then(
        (m) => m.AmministrazioneModule
      ),
  },
  {
    path: UrlSettingsCore.URL_CANCELLERIA_TELEMATICA,
    data: {title: 'Cancelleria telematica'},
    canActivate: [],
    loadChildren: () =>
    import('./pda/pda.module').then(
      (m) => m.PdaModule
    ),
  },
  {
    path: UrlSettingsCore.URL_PROFILO_UTENTI, data: {title: 'Profilo utenti',descrittore: 'GestioneUtenti'},
    canActivate: [AuthGuardAmministrazioneService],
    loadChildren: () =>
      import('./gestione-profilo-utenti/gestione-profilo-utenti.module').then(
        (m) => m.GestioneProfiloUtentiModule
      ),
  },
  {
    path: UrlSettingsCore.URL_TEMPLATE_PROFILI_UTENTE, data: {title:'Template profilo utente', descrittore: 'GestioneProfili'},
    canActivate: [AuthGuardAmministrazioneService],
    loadChildren: () =>
      import(
        './gestione-template-profili-utente/gestione-template-profili-utente.module'
      ).then((m) => m.GestioneTemplateProfiliUtenteModule),
  },
  /* {
    path: UrlSettingsCore.URL_GESTIONE_CDA,
    loadChildren: () =>
      import('./gestione-cda/gestione-cda.module').then(
        (m) => m.GestioneCdaModule
      ),
  }, */
  {
    path: UrlSettingsCore.URL_UTILITY,
    data: {title: 'Utility'},
    loadChildren: () =>
      import('./utility/utility.module').then((m) => m.UtilityModule),
  },
  {
    path: UrlSettingsCore.URL_SCHEDA_ANALITICA,
    data: {title: 'Scheda analitica'},
    loadChildren: () =>
      import('./scheda-analitica/scheda-analitica.module').then(
        (m) => m.SchedaAnaliticaModule
      ),
  },
  {
    path: UrlSettingsCore.URL_SCHEDA_SINTETICA,
    data: {title: 'Scheda sintetica'},
    loadChildren: () =>
      import('./scheda-sintetica/scheda-sintetica.module').then(
        (m) => m.SchedaSinteticaModule
      ),
  },
  {
    path: UrlSettingsCore.URL_STAMPA_SCHEDE,
    data: {title: 'Stampa schede'},
    loadChildren: () =>
      import('./utility/utility.module').then((m) => m.UtilityModule),
  },
  {
    path: UrlSettingsCore.URL_REPORT,
    data: {title: 'Report'},
    loadChildren: () =>
      import('./report/report.module').then((m) => m.ReportModule),
  },
  // LAVORO
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_LAVORO,
    data: {title: 'Pratica lavoro'},
    loadChildren: () =>
      import('./lavoro/pratica/pratica-lavoro.module').then(
        (m) => m.PraticaLavoroModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_LAVORO_CREATE,
    data: {title: 'Creazione Pratica lavoro'},
    loadChildren: () =>
      import('./lavoro/creazionePratica/pratica-lavoro-create.module').then(
        (m) => m.PraticaLavoroCreateModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_LAVORO,
    data: {title: 'Pratica lavoro - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import('./lavoro/fascicoloGeneric/fascicolo-generic.module').then(
        (m) => m.FascicoloGenericModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_LAVORO_CREATE,
    data: {title: 'Pratica lavoro - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './lavoro/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_LAVORO_INS,
    data: {title: 'Pratica lavoro - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './lavoro/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  // AMMINISTRATIVA
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_AMMINISTRATIVA,
    data: {title: 'Pratica amministrativa'},
    loadChildren: () =>
      import('./amministrativa/pratica/pratica-amministrativa.module').then(
        (m) => m.PraticaAmministrativaModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_AMMINISTRATIVA_CREATE,
    data: {title: 'Creazione pratica amministrativa'},
    loadChildren: () =>
      import(
        './amministrativa/creazionePratica/pratica-amministrativa-create.module'
      ).then((m) => m.PraticaAmministrativaCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA,
    data: {title: 'Pratica amministrativa - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import('./amministrativa/fascicoloGeneric/fascicolo-generic.module').then(
        (m) => m.FascicoloGenericModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA_CREATE,
    data: {title: 'Pratica amministrativa - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './amministrativa/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA_INS,
    data: {title: 'Pratica amministrativa - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './amministrativa/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  // CIVILE
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_CIVILE, data: {title: 'Pratica civile'},
    loadChildren: () =>
      import('./civile/pratica/pratica-civile.module').then(
        (m) => m.PraticaCivileModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_CIVILE_CREATE, data: {title: 'Creazione pratica civile'},
    loadChildren: () =>
      import('./civile/creazionePratica/pratica-civile-create.module').then(
        (m) => m.PraticaCivileCreateModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_CIVILE,
    data: {title: 'Pratica civile - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import('./civile/fascicoloGeneric/fascicolo-generic.module').then(
        (m) => m.FascicoloGenericModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_CIVILE_CREATE,
    data: {title: 'Pratica civile - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './civile/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_CIVILE_INS,
    data: {title: 'Pratica civile - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './civile/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  // TRIBUTARIO
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_TRIBUTARIO,
    data: {title: 'Pratica tributaria'},
    loadChildren: () =>
      import('./tributario/pratica/pratica-tributario.module').then(
        (m) => m.PraticaTributarioModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_TRIBUTARIO_CREATE,
    data: {title: 'Creazione pratica tributaria'},
    loadChildren: () =>
      import(
        './tributario/creazionePratica/pratica-tributario-create.module'
      ).then((m) => m.PraticaTributarioCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_TRIBUTARIO,
    data: {title: 'Pratica tributaria - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import('./tributario/fascicoloGeneric/fascicolo-generic.module').then(
        (m) => m.FascicoloGenericModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_TRIBUTARIO_CREATE,
    data: {title: 'Pratica tributaria - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './tributario/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_TRIBUTARIO_INS,
    data: {title: 'Pratica tributaria - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './tributario/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  // PENALE
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_PENALE,
    data: {title: 'Pratica penale'},
    loadChildren: () =>
      import('./penale/pratica/pratica-penale.module').then(
        (m) => m.PraticaPenaleModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_PENALE_CREATE,
    data: {title: 'Creazione pratica penale'},
    loadChildren: () =>
      import('./penale/creazionePratica/pratica-penale-create.module').then(
        (m) => m.PraticaPenaleCreateModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_PENALE,
    data: {title: 'Pratica penale - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import('./penale/fascicoloGeneric/fascicolo-generic.module').then(
        (m) => m.FascicoloGenericModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_PENALE_CREATE,
    data: {title: 'Pratica penale - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './penale/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_PENALE_INS,
    data: {title: 'Pratica penale - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './penale/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  // PARERISTICA
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_PARERISTICA,
    data: {title: 'Pratica consulenza'},
    loadChildren: () =>
      import('./pareristica/pratica/pratica-pareristica.module').then(
        (m) => m.PraticaPareristicaModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_PARERISTICA_CREATE,
    data: {title: 'Creazione pratica consulenza'},
    loadChildren: () =>
      import(
        './pareristica/creazionePratica/pratica-pareristica-create.module'
      ).then((m) => m.PraticaPareristicaCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_PARERISTICA,
    data: {title: 'Pratica consulenza - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import('./pareristica/fascicoloGeneric/fascicolo-generic.module').then(
        (m) => m.FascicoloGenericModule
      ),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_PARERISTICA_CREATE,
    data: {title: 'Pratica consulenza - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './pareristica/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_PARERISTICA_INS,
    data: {title: 'Pratica consulenza - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './pareristica/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  // AUTORITA INDIPENDENTE
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_AUTORITA_INDIPENDENTE,
    data: {title: 'Pratica autorità indipendente'},
    loadChildren: () =>
      import(
        './autorita-indipendente/pratica/pratica-autorita-indipendente.module'
      ).then((m) => m.PraticaAutoritaIndipendenteModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_PRATICA_AUTORITA_INDIPENDENTE_CREATE,
    data: {title: 'Creazione pratica autorità indipendente'},
    loadChildren: () =>
      import(
        './autorita-indipendente/creazionePratica/pratica-autorita-indipendente-create.module'
      ).then((m) => m.PraticaAutoritaIndipendenteCreateModule),
  },
  {
    path: UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AUTORITA_INDIPENDENTE,
    data: {title: 'Pratica autorità indipendente - fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './autorita-indipendente/fascicoloGeneric/fascicolo-generic.module'
      ).then((m) => m.FascicoloGenericModule),
  },
  {
    path:
      UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AUTORITA_INDIPENDENTE_CREATE,
      data: {title: 'Pratica autorità indipendente - creazione fascicolo'},
    // canActivate: [authGuardVisibilityFN],
    // canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './autorita-indipendente/creazioneFascicoloGeneric/fascicolo-generic-create.module'
      ).then((m) => m.FascicoloGenericCreateModule),
  },
  {
    path:
      UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AUTORITA_INDIPENDENTE_INS,
      data: {title: 'Pratica autorità indipendente - inserimento fascicolo'},
    canActivate: [authGuardVisibilityFN],
    canActivateChild: [authGuardVisibilityFN],
    loadChildren: () =>
      import(
        './autorita-indipendente/inserimentoFascicoloGeneric/fascicolo-generic-ins.module'
      ).then((m) => m.FascicoloGenericInsModule),
  },
  {
    path: UrlSettingsCore.URL_GESTIONE_DOCUMENTI,
    data: {title: 'Gestione documenti'},
    loadChildren: () =>
      import('./document-management/document-management.module').then(
        (m) => m.DocumentManagementModule
      ),
  },
  {
    path:
      UrlSettingsCore.URL_GESTIONE_SOCIETA,
    data: {title: 'Gestione società'},
    loadChildren: () =>
      import(
        "./lem/pages/amministrazione/gestionesocieta-lem.module"
      ).then((m) => m.GestioneSocietaModule),
  },
  {
    path:
      UrlSettingsCore.URL_ORGANI_LEM,
    data: {title: 'Organi Legal entity management'},
    loadChildren: () =>
      import(
        './lem/pages/organi/organi.module'
      ).then((m) => m.OrganiModule),
  },
  {
    path:
      UrlSettingsCore.URL_DIPARTIMENTI_LEM,
    data: {title: 'Dipartimenti Legal entity management'},
    loadChildren: () =>
      import(
        './lem/pages/dipartimenti/dipartimenti.module'
      ).then((m) => m.DipartimentiModule),
  },
  {
    path:
      UrlSettingsCore.URL_RUBRICA_LEM,
    data: {title: 'Rubrica Legal entity management'},
    loadChildren: () =>
      import(
        './lem/pages/person/person.module'
      ).then((m) => m.PersonModule),
  },
  { path: 'not-found', component: NotFoundComponent, data: {title: 'Pagina non trovata'}, },
  { path: '**', redirectTo: '/not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
